<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div.pop-out{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background-color: rgba( 55, 44, 12, .29 );
        z-index: 9999;

        div.pop-out-side-bar {
            position: fixed;
            right: 0;
            bottom: 0;
            top: 0;
            width: 250px;
            background-color: white;
            box-shadow: -2px 0 4px 0 rgba(3,27,78,0.10);
            padding: 20px;

            div.side-bar-link {
                border-bottom: 1px solid #BABABA;
                font-size: 16px;
                font-weight: bold;
                font-family: 'Raleway', sans-serif;
                text-transform: uppercase;
                text-align: center;
                padding-top: 20px;
                padding-bottom: 20px;

                a {
                    color: black;

                    &:hover {
                        color: $secondary-color;
                    }
                }
            }

            div.current-type {
                font-size: 12px;
                font-weight: bold;
                font-family: 'Raleway', sans-serif;
                text-align: center;
                color: #929292;
                padding-bottom: 10px;
            }

            div.side-bar-link-logout {
                display: none;
                border-bottom: 1px solid #BABABA;
                font-size: 16px;
                font-weight: bold;
                font-family: 'Raleway', sans-serif;
                text-transform: uppercase;
                text-align: center;
                padding-top: 20px;
                padding-bottom: 20px;

                a {
                    color: black;

                    &:hover {
                        color: $secondary-color;
                    }
                }
            }

            div.license-plate-container-mobile-view {
                display: none;
                margin-top: 16px;
                text-align: center;
            }

            div.language-switch-container-mobile-view {
                display: none;

                div#lang-switcher-view {
                    float: none;
                    margin-right: auto;
                    margin-left: auto;
                    width: 127px;

                    span.switch-button {
                        padding: 5px 20px;
                    }
                }
            }

            div.app-version {
                font-size: 12px;
                font-weight: bold;
                font-family: 'Raleway', sans-serif;
                text-align: center;
                color: #929292;
                padding-top: 20px;
                padding-bottom: 20px;
            }

            span.license-plate-mobile-view {
                color: #333333;
                background-color: #ffffff;
                background-image: url('/img/license-plate/cz.png');
                background-size: 11.5px;
                background-repeat: no-repeat;
                font-family: 'Raleway', sans-serif;
                font-size: 18px;
                font-weight: bold;
                text-transform: uppercase;
                text-align: center;
                padding-left: 20px;
                padding-right: 10px;
                width: 120px;
                height: 50px;
                border: 2px solid #333333;
                border-radius: 5px;
                outline: none;
            }

            img.close-menu-icon {
                float: right;
                cursor: pointer;
            }
        }
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        div.license-plate-container-mobile-view {
            display: block !important;
        }

        div.language-switch-container-mobile-view {
            display: block !important;
        }

        div.side-bar-link-logout {
            display: block !important;
        }
    }

    /* Medium only */
    @media screen and (min-width: 40em) and (max-width: 63.9375em) {
        div.license-plate-container-mobile-view {
            display: block !important;
        }

        div.language-switch-container-mobile-view {
            display: block !important;
        }

        div.side-bar-link-logout {
            display: block !important;
        }
    }

    /* Large only */
    @media screen and (min-width: 64em) and (max-width: 74.9375em) {

    }
</style>

<template>
    <div class="pop-out" v-show="showPopOut" v-on:click="hideNav()">
        <transition name="slide-in-right">
            <div class="pop-out-side-bar" v-show="showRightNav" v-on:click.stop>
                <img src="/img/close-menu.svg" class="close-menu-icon" v-on:click="hideNav()"/>
                <!--
                <div class="side-bar-link">
                    <a :href="$t('general.companyLink')" target="_blank">
                        Drivalia
                    </a>
                </div>
                <div class="side-bar-link">
                    <a :href="$t('general.contactLink')" target="_blank">
                        {{ $t('general.contact') }}
                    </a>
                </div>
                <div class="side-bar-link" v-show="workroom != 860">
                    <a v-on:click="changeServiceType()">
                        {{ $t('servicetype.heading') }}
                    </a>
                </div>
                -->

                <div class="side-bar-link-logout">
                    <a v-on:click="logout()">
                        {{ $t('auth.logoutButton') }}
                    </a>
                </div>

                <div class="license-plate-container-mobile-view" v-if="licensePlate">
                    <span class="license-plate-mobile-view">{{ licensePlate }}</span>
                </div>

                <div class="language-switch-container-mobile-view">
                    <lang-switcher />
                </div>

                <!--
                <div class="app-version">
                    {{ $t('general.applicationVersion') }} 1.8.9
                </div>
                -->
            </div>
        </transition>
    </div>
</template>

<script>
    import {EventBus} from "../../event-bus";
    import API from "../../api/service";
    import LangSwitcher from "./LangSwitcher.vue";

    export default {
        components: {
            LangSwitcher
        },

        computed: {
            showPopOut() {
                return this.$store.getters.getShowPopOut;
            },

            showRightNav() {
                return this.showPopOut;
            },

            licensePlate() {
                return this.$store.getters.getLicensePlate;
            },

            workroom() {
                return this.$store.getters.getWorkroom;
            },

            makeId() {
                return this.$store.getters.getMakeId;
            },
        },

        methods: {
            hideNav() {
                this.$store.dispatch('toggleShowPopOut', { showPopOut: false });
            },

            changeServiceType() {
                if (this.licensePlate) {
                    API.postAuthorize(this.licensePlate)
                        .then((response) => {
                            if (response.status === 200) {
                                EventBus.$emit('prompt-switch-type', response);

                                this.$store.dispatch('toggleShowPopOut', { showPopOut: false });
                            }
                        })
                        .catch((error) => {
                            this.logout();

                            this.$store.dispatch('flashMessageShow', { type: 'error', message: this.$t('auth.errorMessageLogin') }, { root: true })
                        });
                } else {
                    localStorage.clear();

                    this.$router.replace({ name: 'login' });

                    window.location.reload();
                }
            },

            logout() {
                this.$store.dispatch('toggleShowPopOut', { showPopOut: false });

                this.$store.dispatch('logoutClient').then(() => {}, () => {}).finally(() => {
                    localStorage.clear();

                    this.$store.commit('setDistanceFilter', 10);
                    this.$store.commit('setClientCurrentLocation', '');
                    this.$store.commit('setServices', []);
                    this.$store.commit('setLicensePlate', null);
                    this.$store.commit('setClientPersonalData', null);

                    this.$router.replace({ name: 'login' });

                    window.location.reload();
                });
            }
        }
    }
</script>
